import { render, staticRenderFns } from "./dimension.vue?vue&type=template&id=5b33c384&scoped=true"
import script from "./dimension.vue?vue&type=script&lang=js"
export * from "./dimension.vue?vue&type=script&lang=js"
import style0 from "./dimension.vue?vue&type=style&index=0&id=5b33c384&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b33c384",
  null
  
)

export default component.exports